export const QUIZ_SET_ID = 'QUIZ_SET_ID';
export const QUIZ_SET_STYLES = 'QUIZ_SET_STYLES';
export const QUIZ_UPDATE_STYLE = 'QUIZ_UPDATE_STYLE';
export const QUIZ_RESET_STATE = 'QUIZ_RESET_STATE';



/** WEBPACK FOOTER **
 ** ./src/store/modules/quiz/types.js
 **/